import { EventsList } from './Events.list';
import { useCalendarEventList } from '../useCalendarEventList';
import { EmptyList } from './Events.empty-list';
import { EventListLoader } from './Events.list-loader';
import { EventTypeFilter } from '../types';

export const EventsSection = ({
  selectedDate,
  maxDate,
  calendarLoading,
  selectedVendorIds,
  selectedEventType,
}: {
  selectedDate: string;
  maxDate: string;
  calendarLoading: boolean;
  selectedVendorIds: string[];
  selectedEventType: EventTypeFilter[];
}) => {
  const {
    eventsByDate,
    loading,
    showEventList,
    startDate,
    endDate,
    scrolledIntoSelectDay,
    setScrolledIntoSelectDay,
    isRefetching,
  } = useCalendarEventList({
    selectedDate,
    maxDate,
    selectedVendorIds,
    selectedEventType,
  });

  if (loading || calendarLoading) {
    return <EventListLoader />;
  }

  return (
    <>
      {showEventList ? (
        <EventsList
          eventsByDate={eventsByDate}
          selectedDay={selectedDate}
          scrolledIntoSelectDay={scrolledIntoSelectDay}
          setScrolledIntoSelectDay={setScrolledIntoSelectDay}
          isRefetching={isRefetching}
        />
      ) : (
        <EmptyList eventDate={selectedDate} startDate={startDate} endDate={endDate} />
      )}
    </>
  );
};

export default EventsSection;
